var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from 'react';
import * as Styled from 'Styles/Layout.styled';
import { ContainerQueryContext } from '../../util/ContainerQuery.context';
/**
 * Layout component that implements the Design System 12 column grid.
 *
 * The Layout component is used at the highest level with sub components specificing which columns to start/span.
 */
var Layout = function (_a) {
    var children = _a.children, className = _a.className, props = __rest(_a, ["children", "className"]);
    var styleQueryMode = useContext(ContainerQueryContext).styleQueryMode;
    return (React.createElement(Styled.Layout, __assign({}, props, { className: className, "$styleQueryMode": styleQueryMode }), children));
};
export default Layout;
